import { WebColorScheme } from '@libs/shared/api';

export function convertToFuseScheme(
  webColorScheme: WebColorScheme
): 'auto' | 'dark' | 'light' {
  switch (webColorScheme) {
    case 'Auto':
      return 'auto';
    case 'Light':
      return 'light';
    case 'Dark':
      return 'dark';
  }
}
